<package-receive-progress></package-receive-progress>
<div class="steps-content">
  <p-card>
    <ng-template pTemplate="title">
      Client Selection
    </ng-template>
    <ng-template pTemplate="subtitle">
      Select the client that sent us the package or indicate that the correct client cannot be found
    </ng-template>
    <ng-template pTemplate="content">
      <div class="row">
        <div class="col-3 h4">
        </div>
        <div class="col-6">
          <input name="cSS" type="text" [(ngModel)]="clientSearchString" pInputText placeholder="Client Search" (keyup.enter)="doClientSearch()" [style]="{'width':'300px','height':'30px'}">
          <button (click)="doClientSearch()" style="margin-left:10px; padding:4px"><i class="fa fa-search fa-3x"></i></button>
          <button *ngIf="package.FromCity && textSearch" (click)="doClientAddressSearch()" style="margin-left:10px; padding:4px" title="Search by address"><i class="far fa-map-marked fa-3x"></i></button>
          <div style="width:100%; max-height: 300px; overflow: auto">
            <div *ngFor='let item of clients;let i = index' class="ml-2">
              <input id="client_{{i}}" type="radio" [checked]="item.selected" (click)='radioChecked(item.Id,i)' class="mr-3" /> <label for="client_{{i}}" class="font-weight-bold">{{item.Name + ' --> ' + item.Address1 + ' ' + item.Address2 + ' ' + item.City + ', ' + item.State + ' ' + item.ZipCode}}</label>
            </div>
          </div>
        </div>
        <div class="col-3 h4">
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="grid p-nogutter p-justify-between">
        <button (click)="prevPage()" icon="pi pi-angle-left" class="navbutton">Back</button>
        <button [hidden]="package.FromCity" (click)="searchByClientAddress()" icon="pi pi-angle-right" iconPos="right" class="navbutton">Search By Address</button>
        <!--<button (click)="nextPage()" icon="pi pi-angle-right" iconPos="right" class="navbutton">Client Not Found</button>-->
        <button [hidden]="!package.FromCity" (click)="nextPage()" icon="pi pi-angle-right" iconPos="right" class="navbutton">Next</button>
      </div>
    </ng-template>
  </p-card>
</div>
<p-toast>
</p-toast>
